import React, { useState, useEffect } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import { Grid, Typography, CircularProgress, Button } from '@material-ui/core/';
import ButtonMUI from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { ExcelIcon } from '../../../core/themes/icons/ExcelIcon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import FileInput from '../../../core/components/forked/input/FileInput';
import FileField from '../../../core/components/forked/field/FileField';
import { FormDataConsumer, refreshView, Loading } from 'react-admin';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import FundApi from '../../../core/apis/FundApi';
import TenantConfigurationApi from '../../../core/apis/TenantConfigurationApi';
import { useNotify } from 'ra-core';
import { getIcError } from '../../../core/providers/utils';
import { saveAs } from 'file-saver';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import ErrorIcon from '@material-ui/icons/Error';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';
import { Form, Field } from 'react-final-form';
import CheckBoxField from '../../../core/components/CheckBoxField';
import { Box } from '@material-ui/core';

const styles = {
  avatar: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    height: '36px',
    width: '36px',
    color: '#757575'
  },
  errorIcon: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    color: 'red'
  },
  warningIcon: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    color: 'orange'
  },
  toolbarStyle: {
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E5E5',
    minHeight: '54px',
    paddingTop: '0',
    paddingBottom: '0'
  },
  firstButtonStyle: {
    minHeight: '30px',
    padding: '5px 10px'
  },
  buttonStyle: {
    minHeight: '30px',
    padding: '5px 10px',
    marginRight: '10px'
  },
  root: {
    flexGrow: 1
  },
  barTitle: {
    flexGrow: 1,
    paddingLeft: '8px'
  },
  label: {
    paddingRight: '0px'
  },
  horisontalRule: {
    height: '1px',
    backgroundColor: '#E0E0E0',
    border: 'none'
  },
  ButtonMUISpan: {
    paddingLeft: '4px'
  },
  excelIcon: {
    verticalAlign: 'middle',
    paddingRight: '10px'
  },
  paperWidthFalse: {
    height: 'inherit',
    width: '100%'
  },
  leftWrapper: {
    flexGrow: 1
  },
  validateButton: {
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  circularProgress: {
    paddingRight: '3px'
  },
  validateButtonText: {
    color: 'grey'
  },
  validationColumn: {
    color: 'red'
  },
  validationColumnWarning: {
    color: 'orange'
  },
  noRows: {
    color: 'red'
  },
  tabsStyle: {
    color: 'black',
    background: 'transparent'
  },
  tableWrapper: {
    maxHeight: '70vh',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  table: {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 364px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  }
};

const AvatarImage = withStyles(styles)(({ classes, icon }) => {
  return <Avatar className={classes.avatar}>{icon}</Avatar>;
});

const ExcelIconImage = withStyles(styles)(({ classes, icon }) => {
  return <ExcelIcon className={classes.excelIcon}>{icon}</ExcelIcon>;
});

const ErrorImage = withStyles(styles)(({ classes, icon }) => {
  return <ErrorIcon className={classes.errorIcon}>{icon}</ErrorIcon>;
});

const WarningImage = withStyles(styles)(({ classes, icon }) => {
  return <ErrorIcon className={classes.warningIcon}>{icon}</ErrorIcon>;
});

const StyledFileInput = withStyles({
  dropZone: {
    background: '#ffffff',
    border: '1px dashed #E0E0E0'
  },
  removeButton: {
    textAlign: 'center',
    padding: '.5rem'
  }
})(FileInput);

const ExcelFundImportTitleBarWithDropbox = withStyles(styles)(
  ({
    classes,
    type,
    title,
    createUrl,
    secondTitle,
    secondCreateUrl,
    icon,
    hasExportFundExcelPermission,
    hasImportFundExcelPermission,
    hasCreatePermission,
    filters,
    selectedIds,
    ...rest
  }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [importModelViewToggle, setsViewOfImport] = useState(false);
    const [validateButtonVisibile, setValidateButtonVisibility] = useState(
      false
    );
    const [submitting, setSubmitting] = useState(false);
    const [downloadingTemplate, setDownloadingTemplate] = useState(false);
    const [disableImportButton, setImportButtonDisabled] = useState(true);
    const [loaderVisible, setLoaderVisible] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [showNoDataInExcelError, setShowNoDataInExcelError] = useState(false);
    const [isFileFieldDisabled, setIsFileFieldDisabled] = useState(false);
    const [value, setValue] = useState('1');
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState(-1);
    const [response, setResponse] = useState('');
    const [excelPayload, setExcelPayload] = useState(null);
    const [hasValidationErrors, setHasValidationErrors] = useState(false);
    const [tab1ContainsWarning, setTab1ContainsWarning] = useState(false);
    const notify = useNotify();
    const notifyServerError = useNotifyServerError();
    const [showFundBillingTab, setShowBilllingTab] = useState(false);
    const [showBillingModal, setShowBillingModal] = useState(false);
    const fundTableHeaders = [
      { id: 'Row Number' },
      { id: 'Fund ID' },
      { id: 'Fund Name' },
      { id: 'Asset Class' },
      { id: 'A.K.A' },
      { id: 'Start Date' },
      { id: 'Closing Date/As of Date' },
      { id: 'Fund Inception Date' },
      { id: 'Fund Contact Email' },
      { id: 'Currency' },
      { id: 'Alternative Currency' },
      { id: 'Fund Family ID' },
      { id: 'Publishing Status' },
      { id: 'Data Room' },
      { id: 'Fund Type' },
      { id: 'Target Commitment' },
      { id: 'Target Number Of Investors' },
      { id: 'Investment Structure' },
      { id: 'Main Fund ID' },
      { id: 'Validation Error / Warning Message' }
    ];

    useEffect(() => {
      TenantConfigurationApi.get('Fund Self-Serve')
        .then(response => {
          setShowBilllingTab(
            response?.pageData[0]?.value === '1' ? true : false
          );
        })
        .catch(error => notifyServerError(error));
    }, [notifyServerError, importModelViewToggle]);

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleImportClick = () => {
      setAnchorEl(null);
      setsViewOfImport(true);
    };

    const handleCloseImportClick = () => {
      setAnchorEl(null);
      cleanUpData();
      setsViewOfImport(false);
    };

    const columnDirectionSort = (sortColumnName, isDesc) => {
      return function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowNumber') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return x < y ? -1 : x > y ? 1 : 0;
        } else {
          return x < y ? 1 : x > y ? -1 : 0;
        }
      };
    };

    const handleRequestSort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowNumber';
          break;
        case 1:
          sortColumnName = 'fundId';
          break;
        case 2:
          sortColumnName = 'fundName';
          break;
        case 3:
          sortColumnName = 'fundType';
          break;
        case 4:
          sortColumnName = 'aka';
          break;
        case 5:
          sortColumnName = 'startDate';
          break;
        case 6:
          sortColumnName = 'closingDate';
          break;
        case 7:
          sortColumnName = 'inceptionDate';
          break;
        case 8:
          sortColumnName = 'contactEmail';
          break;
        case 9:
          sortColumnName = 'currency';
          break;
        case 10:
          sortColumnName = 'alternativeCurrency';
          break;
        case 11:
          sortColumnName = 'fundFamily`';
          break;
        case 12:
          sortColumnName = 'status';
          break;
        case 13:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNumber';
      }

      var sortedTableData = response.sort(
        columnDirectionSort(sortColumnName, isDesc)
      );

      setResponse(sortedTableData);
    };

    const cleanUpData = value => {
      setShowGrid(false);
      setTab1ContainsWarning(false);
      setImportButtonDisabled(true);
      if (value) {
        setValidateButtonVisibility(true);
      } else {
        setValidateButtonVisibility(false);
      }
    };

    function getExcelPayload(values) {
      const payload = new FormData();
      if (values.file) {
        payload.append('excelFile', values.file.rawFile, values.file.title);
      }
      return payload;
    }

    const handleClickValidation = async values => {
      const payload = getExcelPayload(values);

      setValidateButtonVisibility(false);
      setImportButtonDisabled(true);
      setLoaderVisible(true);
      setIsFileFieldDisabled(true);

      FundApi.validateImportFromExcel(payload)
        .then(responseData => {
          var arrayData = responseData;
          setResponse(arrayData);

          const validationErrors = arrayData
            .slice(0)
            .filter(r => r.validationError !== '');
          const warningMessage = arrayData
            .slice(0)
            .filter(r => r.warningMessage !== '');
          if (arrayData.length > 0) {
            const validationErrorsExist =
              validationErrors && validationErrors.length > 0;
            setHasValidationErrors(validationErrorsExist);
            setTab1ContainsWarning(warningMessage && warningMessage.length > 0);
            // couldn't use the hasValidationErrors state...
            setImportButtonDisabled(validationErrorsExist);
            setShowNoDataInExcelError(false);
          } else {
            setImportButtonDisabled(true);
            setShowNoDataInExcelError(true);
          }

          setLoaderVisible(false);
          setIsFileFieldDisabled(false);
          setShowGrid(true);
          setExcelPayload(payload);
        })
        .catch(e => {
          setExcelPayload(null);
          setLoaderVisible(false);
          setIsFileFieldDisabled(false);
          notify(getIcError(e), { type: 'error' });
        });
    };

    const handleImportFundsClick = () => {
      if (showFundBillingTab) {
        setShowBillingModal(true);
        return;
      }

      proceedWithImport(false);
    };

    const proceedWithImport = fundBillingAcknowledgement => {
      if (!excelPayload) {
        setImportButtonDisabled(true);
        return;
      }

      setImportButtonDisabled(true);
      setLoaderVisible(true);
      setShowGrid(false);

      FundApi.importFundsFromExcel(excelPayload, {
        fundBillingAcknowledgement
      })
        .then(() => {
          notify('ra.notification.custom_updated_message');
        })
        .catch(e => {
          setLoaderVisible(false);
          notifyServerError(e);
        })
        .finally(() => {
          setLoaderVisible(false);
          setsViewOfImport(false);
          handleCloseImportClick();
          refreshView();
        });
    };

    const handleTemplateDownload = () => {
      setDownloadingTemplate(true);
      FundApi.downloadFundImportTemplate()
        .then(resp => {
          const fileName = 'Fund Import Template.xlsx';
          saveAs(resp, fileName);
        })
        .catch(e => {
          notifyServerError(e);
        })
        .finally(() => {
          setDownloadingTemplate(false);
        });
    };

    const handleExportClick = filters => {
      setSubmitting(true);
      FundApi.exportFundsExcel(
        filters.id,
        filters.name,
        filters.fundFamilyId,
        filters.fundTagId,
        filters.status,
        selectedIds
      )
        .then(resp => {
          const fileName = 'Funds Export.xlsx';
          saveAs(resp, fileName);
          setSubmitting(false);
        })
        .catch(e => {
          notifyServerError(e);
          setSubmitting(false);
        });
    };

    return (
      <Toolbar className={classes.toolbarStyle}>
        <AvatarImage icon={icon} />
        <Typography
          style={{ fontSize: '20px', lineHeight: '28px' }}
          color="textPrimary"
          className={classes.barTitle}
        >
          {type}
        </Typography>
        {
          <div>
            {(hasImportFundExcelPermission || hasExportFundExcelPermission) && (
              <ButtonMUI
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <div className={classes.WrapperClass}>
                  <ExcelIconImage />
                  <span className={classes.ButtonMUISpan}>
                    Import/Export Funds
                  </span>
                </div>
              </ButtonMUI>
            )}
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {hasImportFundExcelPermission && (
                <MenuItem onClick={handleImportClick}>
                  Import Funds from Excel
                </MenuItem>
              )}
              {hasExportFundExcelPermission && (
                <MenuItem
                  onClick={() => handleExportClick(filters)}
                  disabled={submitting}
                >
                  {submitting && (
                    <span className={classes.circularProgress}>
                      <CircularProgress size={'15px'} />
                    </span>
                  )}
                  Export Funds to Excel
                </MenuItem>
              )}

              {hasImportFundExcelPermission && (
                <div>
                  <hr className={classes.horisontalRule} />
                  <MenuItem
                    onClick={handleTemplateDownload}
                    disabled={downloadingTemplate}
                  >
                    {downloadingTemplate && (
                      <span className={classes.circularProgress}>
                        <CircularProgress size={'15px'} />
                      </span>
                    )}
                    Download Template
                  </MenuItem>
                </div>
              )}
            </Menu>
          </div>
        }

        {hasCreatePermission && title && (
          <Button
            className={classes.firstButtonStyle}
            variant="contained"
            color="primary"
            href={createUrl}
          >
            {title}
          </Button>
        )}

        <Dialog
          open={importModelViewToggle}
          aria-label="Import Funds from Excel"
          maxWidth={false}
          onClose={(event, reason) => {
            if (reason === 'backdropClick') return null;
            if (reason === 'escapeKeyDown') return handleCloseImportClick();
          }}
          classes={{
            paperWidthFalse: classes.paperWidthFalse // class name, e.g. `classes-nesting-root-x`
          }}
        >
          <DialogTitleWithCloseButton onClose={handleCloseImportClick}>
            Import Funds from Excel
          </DialogTitleWithCloseButton>

          <DialogContent>
            <div>
              <CustomSimpleForm
                toolbar={null}
                variant="standard"
                margin="normal"
              >
                <FormDataConsumer>
                  {({ formData, ...rest }) => (
                    <Grid>
                      {!isFileFieldDisabled && (
                        <StyledFileInput
                          source="file"
                          label="Import File"
                          accept={
                            'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                          }
                          placeholder="Drag and drop File Here or Upload"
                          variant="standard"
                          onChange={value => cleanUpData(value)}
                        >
                          <FileField
                            source="src"
                            title="title"
                            size="size"
                            type="type"
                          />
                        </StyledFileInput>
                      )}
                      {loaderVisible && <Loading />}

                      {validateButtonVisibile && (
                        <div className={classes.validateButton}>
                          <p className={classes.validateButtonText}>
                            No Data To Display
                            <br />
                            Click 'Validate' to parse and display Excel Data
                          </p>
                          <Button
                            onClick={() => handleClickValidation(formData)}
                            color="primary"
                            variant="contained"
                          >
                            Validate
                          </Button>
                        </div>
                      )}

                      {showGrid && (
                        <div className={classes.root}>
                          <TabContext value={value}>
                            <AppBar
                              position="static"
                              className={classes.tabsStyle}
                            >
                              <TabList aria-label="simple tabs example">
                                <Tab
                                  label="Add or Modify Funds"
                                  value="1"
                                  selectionFollowsFocus
                                  component={React.forwardRef(() => {
                                    return (
                                      <Button onClick={() => setValue('1')}>
                                        {hasValidationErrors && <ErrorImage />}
                                        {!hasValidationErrors &&
                                          tab1ContainsWarning && (
                                            <WarningImage />
                                          )}
                                        Add or Modify Funds
                                      </Button>
                                    );
                                  })}
                                />
                                {/* evading console errors - should find a better way */}
                                <Tab label="" value="2" disabled={true} />
                              </TabList>
                            </AppBar>
                            <TabPanel value="1" selected={true}>
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {fundTableHeaders.map(
                                        (headCell, index) => (
                                          <TableCell
                                            className={classes.cell}
                                            key={headCell.id}
                                            sortDirection={
                                              orderBy === index ? order : false
                                            }
                                          >
                                            <TableSortLabel
                                              active={orderBy === index}
                                              direction={order}
                                              onClick={() =>
                                                handleRequestSort(index)
                                              }
                                            >
                                              {headCell.id}
                                            </TableSortLabel>
                                          </TableCell>
                                        )
                                      )}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {response.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>
                                            {item.rowNumber}
                                          </TableCell>
                                          <TableCell>{item.fundId}</TableCell>
                                          <TableCell>{item.fundName}</TableCell>
                                          <TableCell>
                                            {item.assetClass}
                                          </TableCell>
                                          <TableCell>{item.aka}</TableCell>
                                          <TableCell>
                                            {item.startDate}
                                          </TableCell>
                                          <TableCell>
                                            {item.closingDate}
                                          </TableCell>
                                          <TableCell>
                                            {item.inceptionDate}
                                          </TableCell>
                                          <TableCell>
                                            {item.contactEmail}
                                          </TableCell>
                                          <TableCell>{item.currency}</TableCell>
                                          <TableCell>
                                            {item.alternativeCurrency}
                                          </TableCell>
                                          <TableCell>
                                            {item.fundFamily}
                                          </TableCell>
                                          <TableCell>{item.status}</TableCell>
                                          <TableCell>{item.dataRoom}</TableCell>
                                          <TableCell>{item.fundType}</TableCell>
                                          <TableCell>
                                            {item.targetCommitment}
                                          </TableCell>
                                          <TableCell>
                                            {item.targetNbOfInvestors}
                                          </TableCell>
                                          <TableCell>
                                            {item.investmentStructure}
                                          </TableCell>
                                          <TableCell>{item.mainFund}</TableCell>
                                          <TableCell
                                            className={
                                              hasValidationErrors
                                                ? classes.validationColumn
                                                : classes.validationColumnWarning
                                            }
                                          >
                                            {hasValidationErrors
                                              ? item.validationError
                                              : item.warningMessage}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There is no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                          </TabContext>
                        </div>
                      )}
                    </Grid>
                  )}
                </FormDataConsumer>
              </CustomSimpleForm>
            </div>
          </DialogContent>
          <DialogActions style={{ borderTop: `1px solid rgba(0, 0, 0, 0.12)` }}>
            <div className={classes.leftWrapper}>
              <Button
                onClick={handleCloseImportClick}
                color="primary"
                variant="outlined"
                className={classes.button}
              >
                Close
              </Button>
            </div>
            <Button
              onClick={handleImportFundsClick}
              color="primary"
              variant="contained"
              className={classes.button}
              disabled={disableImportButton}
            >
              Import
            </Button>
          </DialogActions>
        </Dialog>
        {showBillingModal && (
          <Dialog
            open={showBillingModal}
            onClose={() => setShowBillingModal(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>Fund Billing Acknowledgement</DialogTitle>
            <DialogContent>
              <Form
                onSubmit={() => {
                  setShowBillingModal(false);
                  proceedWithImport(true);
                }}
                initialValues={{ acknowledge: false }}
                render={({ handleSubmit, values }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sx={{ p: 2 }}>
                      <Field
                        name="acknowledge"
                        component={CheckBoxField}
                        label="I acknowledge that the creation of this fund may be subject to an additional fee that will be communicated via an order form. *"
                        type="checkbox"
                        parse={value => {
                          return !!value;
                        }}
                        defaultValue={false}
                      />
                    </Box>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                      <Button
                        onClick={() => setShowBillingModal(false)}
                        color="secondary"
                      >
                        Close
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={!values.acknowledge}
                      >
                        Proceed
                      </Button>
                    </DialogActions>
                  </form>
                )}
              />
            </DialogContent>
          </Dialog>
        )}
      </Toolbar>
    );
  }
);

export default ExcelFundImportTitleBarWithDropbox;
